import { useEffect, useState } from 'react';
import { fetchWaitlistCount } from '@/lib/api';
import { useT, useLang } from '@/lib/i18n';

export const WaitlistCounter = ({ variant = 'inline', className = '' }) => {
  const t = useT();
  const { lang } = useLang();
  const [count, setCount] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      const v = await fetchWaitlistCount();
      if (alive) setCount(v);
    })();
    return () => { alive = false; };
  }, []);

  if (count === null || count < 1) return null;

  const locale = lang === 'en' ? 'en-US' : 'fr-FR';
  const formatted = new Intl.NumberFormat(locale).format(count);
  const suffix =
    variant === 'chip'
      ? count > 1 ? t('waitlist.counter_chip_plural') : t('waitlist.counter_chip_single')
      : count > 1 ? t('waitlist.counter_suffix_plural') : t('waitlist.counter_suffix_single');

  if (variant === 'chip') {
    return (
      <span
        data-testid="waitlist-counter"
        className={`inline-flex items-center gap-2 rounded-full border border-[var(--om-border)] bg-white/70 px-3 py-1.5 text-xs font-semibold text-[var(--om-ink)] backdrop-blur ${className}`}
      >
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
        </span>
        {t('waitlist.counter_prefix')} <span className="tabular-nums font-bold">{formatted}</span> {suffix}
      </span>
    );
  }

  return (
    <div
      data-testid="waitlist-counter"
      className={`flex items-center gap-2 text-xs text-[var(--om-muted)] ${className}`}
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
      </span>
      {t('waitlist.counter_prefix')} <span className="tabular-nums font-bold text-[var(--om-ink)]">{formatted}</span> {suffix}
    </div>
  );
};
